import http from '@/plugins/axios_plugin';

class ServiceGraficos {
    
    // Administradores

    vendasAdm(rodada) {
        return http.get('/api/graficos/vendas?tipousuario=adm' + '&rodada=' + rodada)
    }
    
    vendasPorFornecedorAdm(rodada) {
        return http.get('/api/graficos/vendas-por-fornecedor?tipousuario=adm' + '&rodada=' + rodada)
    }
    
    vendasPorRepresentanteAdm(rodada) {
        return http.get('/api/graficos/vendas-por-representante?tipousuario=adm' + '&rodada=' + rodada)
    }
    
    vendasPorClienteAdm(rodada) {
        return http.get('/api/graficos/vendas-por-cliente?tipousuario=adm' + '&rodada=' + rodada)
    }
    
    vendasPorEstadoAdm(rodada) {
        return http.get('/api/graficos/vendas-por-estado?tipousuario=adm' + '&rodada=' + rodada)
    }
    
    vendasPorRegiaoAdm(rodada) {
        return http.get('/api/graficos/vendas-por-regiao?tipousuario=adm' + '&rodada=' + rodada)
    }
    
    // Fornecedores

    vendasFor(fornecedor, rodada) {
        return http.get('/api/graficos/vendas?tipousuario=for&id=' + fornecedor + '&rodada=' + rodada)
    }
    
    vendasPorRepresentanteFor(fornecedor, rodada) {
        return http.get('/api/graficos/vendas-por-representante?tipousuario=for&id=' + fornecedor + '&rodada=' + rodada)
    }
    
    vendasPorClienteFor(fornecedor, rodada) {
        return http.get('/api/graficos/vendas-por-cliente?tipousuario=for&id=' + fornecedor + '&rodada=' + rodada)
    }
    
    vendasPorEstadoFor(fornecedor, rodada) {
        return http.get('/api/graficos/vendas-por-estado?tipousuario=for&id=' + fornecedor + '&rodada=' + rodada)
    }
    
    vendasPorRegiaoFor(fornecedor, rodada) {
        return http.get('/api/graficos/vendas-por-regiao?tipousuario=for&id=' + fornecedor + '&rodada=' + rodada)
    }
    
    produtosMaisVendidos(fornecedor, rodada) {
        return http.get('/api/graficos/produtos-mais-vendidos?tipousuario=for&id=' + fornecedor + '&rodada=' + rodada)
    }
    
    // Representantes

    vendasRep(representante, rodada) {
        return http.get('/api/graficos/vendas?tipousuario=rep&id=' + representante + '&rodada=' + rodada)
    }
    
    vendasPorFornecedorRep(representante, rodada) {
        return http.get('/api/graficos/vendas-por-fornecedor?tipousuario=rep&id=' + representante + '&rodada=' + rodada)
    }
    
    vendasPorClienteRep(representante, rodada) {
        return http.get('/api/graficos/vendas-por-cliente?tipousuario=rep&id=' + representante + '&rodada=' + rodada)
    }
    
    vendasPorEstadoRep(representante, rodada) {
        return http.get('/api/graficos/vendas-por-estado?tipousuario=rep&id=' + representante + '&rodada=' + rodada)
    }
    
    vendasPorRegiaoRep(representante, rodada) {
        return http.get('/api/graficos/vendas-por-regiao?tipousuario=rep&id=' + representante + '&rodada=' + rodada)
    }
    
}

export default new ServiceGraficos();